import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { FieldReviewDetailsRow } from "../fieldReviewDetailsViewConfig";

export const FieldReviewStatusCell = memo(
    ({
        getValue,
    }: CellContext<ViewTableFeatures, FieldReviewDetailsRow, boolean>) => {
        const isReviewed = getValue();
        return (
            <ViewTableCell>
                {isReviewed ? "Reviewed" : "Unreviewed"}
            </ViewTableCell>
        );
    },
);

FieldReviewStatusCell.displayName = "FieldReviewStatusCell";
